<script>
import TestHeader from './headers/TestHeader.vue';
import SenHeader from './headers/SenHeader.vue';
import CPRHeader from './headers/CprHeader.vue';
import MojHeader from './headers/MojHeader.vue';
import SejongHeader from './headers/SejongHeader.vue';
import PapagoHeader from './headers/PapagoHeader.vue';
import ScourtHeader from './headers/scourtHeader.vue';
import KritHeader from './headers/kritHeader.vue';

export default {
  name: 'commonHeader',
  props: {
    window: Object
  },
  computed: {
    headerComponent() {
      if (this.$route.meta.requiresSenHeader) {
        return SenHeader;
      } else if (this.$route.meta.requiresCPHeader) {
        return CPRHeader;
      } else if (this.$route.meta.requiresTestHeader) {
        return TestHeader;
      } else if (this.$route.meta.requiresMojHeader) {
        return MojHeader;
      } else if (this.$route.meta.requiresSejongHeader) {
        return SejongHeader;
      } else if (this.$route.meta.requiresPapagoHeader) {
        return PapagoHeader;
      } else if (this.$route.meta.requiresScourtHeader) {
        return ScourtHeader;
      } else if (this.$route.meta.requiresKritHeader) {
        return KritHeader;
      }
      return null
    }
  }
}
</script>

<template>
  <div class="header">
    <component :is="headerComponent" />
  </div>
</template>